// extracted by mini-css-extract-plugin
module.exports = {"modal-view":"style_modal-view__1otGH","content":"style_content__2gIWr","img-top-right":"style_img-top-right__CwvEf","img-bottom-left":"style_img-bottom-left__1CQq5"};